import { FancyMultiSelect, SelectType } from '@ais-ui/ui-core';
import { useGetShareGroups } from '@ais-ui/websockets';
import { forwardRef, useEffect, useState } from 'react';

type GroupMultiSelectProps = {
  value: SelectType[];
  onChange: (value: SelectType[]) => void;
  disabled?: boolean;
  disabledReason?: string;
};

export const GroupMultiSelect = forwardRef(
  (
    {
      value,
      onChange,
      disabled = false,
      disabledReason,
    }: GroupMultiSelectProps,
    _ref,
  ) => {
    const { data: groups } = useGetShareGroups();

    const [availableGroupSelectables, setAvailableGroupSelectables] = useState<
      SelectType[]
    >([]);

    useEffect(() => {
      if (groups) {
        const newAvailableGroupSelectables = groups.map((group) => ({
          label: group.name,
          value: group.uuid,
        }));
        setAvailableGroupSelectables(newAvailableGroupSelectables);
      }
    }, [groups]);

    return (
      <FancyMultiSelect
        value={value}
        onChange={onChange}
        availableSelectables={availableGroupSelectables}
        placeholder="Share with..."
        disabled={disabled}
        disabledReason={disabled ? disabledReason : ''}
      />
    );
  },
);
